import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

// Global 402 handler — surfaces the paywall banner + soft-redirects to /upgrade
// when a mutation is blocked by expired trial. Listeners subscribe via
// onPaywallHit; we don't force navigation here because we don't have access
// to react-router inside the axios module.
const paywallListeners = new Set();
export const onPaywallHit = (fn) => {
  paywallListeners.add(fn);
  return () => paywallListeners.delete(fn);
};

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 402) {
      const billing = err.response.data?.billing || null;
      paywallListeners.forEach((fn) => {
        try { fn(billing); } catch (_) { /* ignore */ }
      });
    }
    return Promise.reject(err);
  },
);

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
